<h2 mat-dialog-title>Actualización no completada</h2>

<mat-dialog-content class="mat-typography updateFailedContent">
  <p>
    No se ha podido aplicar la versión <strong>{{ data.serverVersion }}</strong>.
    La aplicación sigue en la versión <strong>{{ data.clientVersion }}</strong>.
  </p>

  <p>Puedes intentar actualizar manualmente de una de estas formas:</p>

  <ul>
    <li>Ir a <strong>Menú &gt; Ayuda</strong> y pulsar el botón <strong>Actualizar</strong>.</li>
    <li>En móvil, pulsa <strong>Forzar actualización</strong> para vaciar la caché de la app.</li>
    <li>Si usas la app instalada en iPhone/iPad, ciérrala por completo desde el conmutador de apps y ábrela de nuevo tras forzar la actualización.</li>
    <li>Vaciar la caché del navegador y volver a cargar la página.</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Entendido</button>
  <button mat-button color="accent" (click)="forceUpdate()">Forzar actualización</button>
  <button mat-button color="primary" (click)="goToHelp()">Ir a Ayuda</button>
</mat-dialog-actions>
